module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-page"
  }, [(_vm.status === 1) ? _c('div', [_c('div', {
    staticClass: "mobile-header"
  }, [_c('div', {
    staticClass: "mobile-title"
  }, [_vm._v(_vm._s(_vm.isGaosan ? '2019高考真题在线估分' : '2019高考真题挑战赛'))]), _vm._v(" "), _c('div', {
    staticClass: "estimate-num"
  }, _vm._l((_vm.numbers), function(n) {
    return _c('span', [_vm._v(_vm._s(n))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "mobile-desc"
  }, [_vm._v(_vm._s(_vm.isGaosan ? '在线估分考生人数' : '在线挑战人数'))]), _vm._v(" "), _c('div', {
    staticClass: "waves"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mobile-content"
  }, [(_vm.estimateStat) ? _c('div', [_c('div', {
    staticClass: "quiz-info"
  }, [_vm._v(_vm._s(_vm.estimateStat.quiz.name) + "\n        " + _vm._s(_vm.estimateStat.major.id === 0 ? '' : ("(" + (_vm.estimateStat.major.name) + ")")))]), _vm._v(" "), _c('div', {
    staticClass: "change-quiz",
    on: {
      "click": function($event) {
        return _vm.changeQuiz('change')
      }
    }
  }, [_vm._v("更换考试省份")])]) : _c('div', {
    staticClass: "change-quiz choose",
    on: {
      "click": function($event) {
        return _vm.changeQuiz('init')
      }
    }
  }, [_vm._v("请选择考试省份")]), _vm._v(" "), _c('div', {
    staticClass: "hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "quiz-num"
  }, [_vm._v(_vm._s(_vm.estimateStat ? _vm.estimateStat.quizUserCount : 0))]), _vm._v(" "), _c('div', {
    staticClass: "quiz-tip"
  }, [_vm._v(_vm._s(_vm.isGaosan ? '参与估分人数' : '参与挑战人数'))]), _vm._v(" "), _c('div', {
    staticClass: "hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "quiz-num"
  }, [_vm._v(_vm._s(_vm.estimateStat ? _vm.estimateStat.topUserCount : 0))]), _vm._v(" "), _c('div', {
    staticClass: "quiz-tip"
  }, [_vm._v("高于 " + _vm._s(_vm.estimateStat ? _vm.estimateStat.threshold : 0) + " 分人数")]), _vm._v(" "), _c('div', {
    staticClass: "footer-btn"
  }, [_c('button', {
    class: {
      disabled: !_vm.estimateStat
    },
    on: {
      "click": _vm.startEstimate
    }
  }, [_vm._v(_vm._s(_vm.isGaosan ? '开始估分' : '开始挑战'))])])]), _vm._v(" "), _c('div', {
    staticClass: "copyright",
    on: {
      "click": function($event) {
        return _vm.gotoUrl()
      }
    }
  }, [_vm._v("北京贞观雨科技有限公司版权所有 关于我们")])]) : (_vm.status === 2) ? _c('div', [_c('div', {
    staticClass: "select-content"
  }, [_c('div', {
    staticClass: "select-title"
  }, [_vm._v("文理分科")]), _vm._v(" "), _c('div', {
    staticClass: "select-list"
  }, _vm._l((_vm.majors), function(m, index) {
    return _c('div', {
      key: index,
      staticClass: "cell major-cell",
      class: {
        active: m.id === _vm.majorId
      },
      on: {
        "click": function($event) {
          _vm.majorId = m.id
        }
      }
    }, [_vm._v(_vm._s(m.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-title"
  }, [_vm._v("选择省份")]), _vm._v(" "), _c('div', {
    staticClass: "select-list"
  }, _vm._l((_vm.quizzes), function(quiz) {
    return _c('city-cell', {
      key: quiz.id,
      attrs: {
        "quiz": quiz,
        "majorId": _vm.majorId,
        "quizId": _vm.quizId
      },
      on: {
        "select": function($event) {
          return _vm.selectSubject(quiz)
        }
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "confirm-btn"
  }, [_c('button', {
    class: {
      disabled: !_vm.confirm
    },
    on: {
      "click": _vm.confirmSelect
    }
  }, [_vm._v("确定")])])]) : _c('div', {
    staticClass: "personal"
  }, [(_vm.status == 3) ? _c('personal', {
    attrs: {
      "majorId": _vm.majorId,
      "quizId": _vm.quizId
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58d8efb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobilePage.vue
// module id = 475
// module chunks = 1